import React from "react";
import { RightOutlined } from "@ant-design/icons";
import "./LandingPage.css";

const apps = [
  { name: "Намаз и омовение", icon: "https://rest-kit.tmweb.ru/image/simolapps/namaz.png", url: "http://onelink.to/ztte5g" },
  { name: "Рузнама", icon: "https://rest-kit.tmweb.ru/image/simolapps/Ruznama.png", url: "http://onelink.to/27xhd5" },
  { name: "Мюрид", icon: "https://rest-kit.tmweb.ru/image/simolapps/Mureed.png", url: "https://simolapps.ru/mureed.php" },
  { name: "Simol Media", icon: "https://rest-kit.tmweb.ru/image/simolapps/Media.png", url: "https://simolapps.ru/simolmedia.php" },
  { name: "Клад мудрости", icon: "https://rest-kit.tmweb.ru/image/simolapps/mudrosti.png", url: "https://simolapps.ru/mudrosti.php" },
  { name: "Мухаммад ﷺ", icon: "https://rest-kit.tmweb.ru/image/simolapps/Muhammad.png", url: "http://onelink.to/rd6f34" },
  { name: "Re2048", icon: "https://rest-kit.tmweb.ru/image/simolapps/re2048.png", url: "https://simolapps.ru/re2048.php" },
  { name: "Ихтибар", icon: "https://rest-kit.tmweb.ru/image/simolapps/ihtibar.png", url: "http://onelink.to/b8kvz8" },
  { name: "Благонравие праведников", icon: "https://rest-kit.tmweb.ru/image/simolapps/blagonravie.png", url: "https://onelink.to/u4h22q" },
  { name: "Салават", icon: "https://rest-kit.tmweb.ru/image/simolapps/salavat.png", url: "http://onelink.to/47cu8h" },
  { name: "Дуа", icon: "https://rest-kit.tmweb.ru/image/simolapps/Dua.png", url: "http://onelink.to/qvhh6q" },
];

function LandingPage() {
  return (
    <main className="apps-page">
      <header className="apps-page__header">
        <h1>Приложения</h1>
      </header>
      <div className="apps-page__grid">
        {apps.map(app => (
          <a
            key={app.name}
            className="apps-page__item"
            href={app.url}
            target="_blank"
            rel="noreferrer"
          >
            <img src={app.icon} alt="" loading="lazy" />
            <span>{app.name}</span>
            <RightOutlined aria-hidden="true" />
          </a>
        ))}
      </div>
    </main>
  );
}

export default LandingPage;
